import { getNativeSDK } from 'native-sdk'
import guaziMapRule from 'native-sdk/lib/mapRules/guazi';
import maodouMapRule from 'native-sdk/lib/mapRules/maodou';
import chesupaiMapRule from 'native-sdk/lib/mapRules/chesupai';
import jianguaziMapRule from "native-sdk/lib/mapRules/jianguazi.js";
import xiangrikuiMapRule from "native-sdk/lib/mapRules/xiangrikui.js";
import chehaomaiMapRule from "native-sdk/lib/mapRules/chehaomai.js";
// 调用getNativeSDK方法获取sdk实例
const config = {
    // 业务线名称
    line: 'c2b',
    // 项目名称
    project: 'cars-protocol',
    invokeVersion: 'v2',
    mapRules: [
        guaziMapRule,
        maodouMapRule,
        chesupaiMapRule,
        jianguaziMapRule,
        xiangrikuiMapRule,
        chehaomaiMapRule,
    ],
    // 调用日志
    log(msg, data) {
        console.log(msg, data)
    },
}

const NativeAPI = getNativeSDK(config)

export default NativeAPI